import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from 'design-system';

export type ConfirmationDialogProps = {
  open: boolean;
  title: string;
  text: string;
  cancelText: string;
  confirmText: string;
  destructive?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmationDialog = ({
  open,
  title,
  text,
  cancelText,
  confirmText,
  destructive = false,
  onCancel,
  onConfirm
}: ConfirmationDialogProps) => (
  <Dialog
    open={open}
    onOpenChange={nextOpen => {
      if (!nextOpen) onCancel();
    }}
  >
    <DialogContent showCloseButton={false}>
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{text}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button
          variant='outline'
          onClick={onCancel}
        >
          {cancelText}
        </Button>
        <Button
          variant={destructive ? 'destructive' : 'default'}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
